<template>
  <div>
    <v-container
      :class="{
        'mx-12': !mobile,
        'my-12': !mobile,
        'pt-6': mobile
      }"
    >
      <div :class="{ 'd-flex': true, 'flex-row': true, 'mb-4': !mobile }">
        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-checkbook</v-icon>
          <p class="mb-0 ml-4 subtitle-1 font-weight-bold">
            Create Post Dated Checks
          </p>
        </div>
      </div>
      <v-form v-model="isFormValid" class="d-flex flex-column">
        <CheckTemplate
          v-for="(item, index) in entries"
          :key="index"
          :item="item"
          :index="index"
          :property="property"
          :remove-p-d-c="removePDC"
          :tenants-list="tenantsList"
          :change-tenant="changeTenant"
        ></CheckTemplate>
      </v-form>
      <p v-if="!mobile" class="caption mx-4">* Required Fields</p>
      <div width="100%" class="d-flex flex-row justify-space-around">
        <div
          :class="{
            'd-flex': mobile,
            'flex-column': mobile
          }"
        >
          <v-btn
            :class="{
              'mx-1': !mobile,
              'mb-2': mobile,
              'font-weight-bold': true
            }"
            depressed
            color="white"
            @click="addAnotherPdc"
          >
            <v-icon class="mr-1">mdi-plus</v-icon>Add another PDC
          </v-btn>
          <v-btn
            color="primary"
            :class="{
              'mx-1': !mobile,
              'my-2': mobile,
              'font-weight-bold': true
            }"
            depressed
            :disabled="!isFormValid"
            @click="finish"
          >
            <v-icon class="mr-1">mdi-send</v-icon>Submit PDCs
          </v-btn>
        </div>
      </div>
    </v-container>
    <v-overlay :value="finishLoading" absolute style="z-index: 9">
      <div class="d-flex flex-column align-center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <p class="white--text mt-2">Creating your Post Dated Checks</p>
        <p class="caption white--text mt-2">Please do not leave this page</p>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { dayjs } from '../../util/date'
import CheckTemplate from './CheckTemplate.vue'

export default {
  components: {
    CheckTemplate
  },
  data() {
    return {
      entries: [
        {
          checkNumber: '',
          accountNumber: '',
          bank: '',
          routingNumber: '',
          amount: 0,
          attachments: [],
          description: '',
          date: dayjs().startOf('day').format('YYYY-MM-DD'),
          dateMenu: false,
          startDate: null,
          endDate: null,
          tenantId: -1,
          category: 'rental',
          unit: {},
          paidUntilDate: null,
          leaseId: -1
        }
      ],
      loading: false,
      finishLoading: false,
      isFormValid: false,
      propertyId: -1
    }
  },
  computed: {
    pdcEntry() {
      return {
        checkNumber: '',
        accountNumber: '',
        bank: '',
        routingNumber: '',
        amount: 0,
        attachments: [],
        description: '',
        date: dayjs().startOf('day').format('YYYY-MM-DD'),
        dateMenu: false,
        startDate: null,
        startDateMenu: false,
        endDate: null,
        endDateMenu: false,
        tenantId: -1,
        category: 'rental',
        unit: {},
        paidUntilDate: null
      }
    },
    currentTenants() {
      return this.$store.getters['users/getTenants'].filter(
        (t) => t.status === 'active' || t.status === 'expired'
      )
    },
    currentProperty() {
      return this.$store.getters['auth/getUser'].selectedProperty
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    units() {
      return this.$store.getters['units/getUnitsFlat']
    },
    tenantsList() {
      return this.currentTenants.map((tenant) => {
        return {
          value: tenant.userId,
          text:
            (tenant.alias && tenant.alias.name) || this.getTenantName(tenant)
        }
      })
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  mounted() {
    this.$store.dispatch('users/fetchTenantsAction')
    this.$store.dispatch('units/fetchUnitsFlatAction', {
      propertyId: this.currentProperty.propertyId
    })
    this.propertyId = this.currentProperty.propertyId
  },
  methods: {
    getTenantName(tenant) {
      let displayName = ''
      if (tenant.firstName) {
        displayName += tenant.firstName + ' '
        if (tenant.lastName) {
          displayName += tenant.lastName + ' '
        }
      } else {
        return (displayName = tenant.username)
      }

      return displayName
    },
    changeTenant(index) {
      // this.entries[index].unit = this.units.find(unit =>
      //   unit.tenantId === this.entries[index].tenantId
      // )

      const sameTenants =
        this.entries.filter(
          (entry) => entry.tenantId === this.entries[index].tenantId
        ).length - 1

      const lastRentalDate = dayjs(
        this.entries[index].unit.nextRentalPeriod.startDate
      )
      const referenceDate = lastRentalDate.add(sameTenants, 'month')
      const dueDaysAfterRental = this.entries[index].unit.dueDaysAfterRental

      if (this.property.defaults && this.property.defaults.useExactDueDate) {
        // use the lease value, else fallback to property default
        let exactDueDateRental =
          this.entries[index].unit.exactDueDateRental ||
          this.property.defaults.exactDueDateRental
        // set the dueDate to the same month of the endDate of the payment temporarily
        let checkDate = dayjs(referenceDate).set(
          'date',
          exactDueDateRental.date
        )
        // adjust if before or after
        if (
          exactDueDateRental.order === 'before' &&
          checkDate.isAfter(dayjs(referenceDate).add(1, 'day'))
        ) {
          checkDate = checkDate.subtract(1, 'month')
        } else if (
          exactDueDateRental.order === 'after' &&
          checkDate.isBefore(dayjs(referenceDate).add(1, 'day'))
        ) {
          checkDate = checkDate.add(1, 'month')
        }

        this.entries[index].date = checkDate.format('YYYY-MM-DD')
      } else {
        this.entries[index].date = referenceDate
          .add(dueDaysAfterRental || 0, 'days')
          .format('YYYY-MM-DD')
      }

      this.entries[index].startDate = lastRentalDate
        .add(sameTenants, 'month')
        .format('YYYY-MM-DD')
      this.entries[index].endDate = lastRentalDate
        .add(sameTenants + 1, 'month')
        .subtract(1, 'day')
        .format('YYYY-MM-DD')

      const entryContractPeriod =
        this.entries[index].unit.contractPeriod &&
        this.entries[index].unit.contractPeriod.contractPeriods.find(
          (period) =>
            dayjs(this.entries[index].startDate).isSameOrAfter(
              dayjs(period.moveInDate)
            ) &&
            dayjs(this.entries[index].startDate).isBefore(
              dayjs(period.moveOutDate)
            )
        )

      this.entries[index].amount =
        (entryContractPeriod && entryContractPeriod.rentFee) ||
        this.entries[index].unit.rentFee

      this.entries[index].paidUntilDate = dayjs(
        this.entries[index].unit.paidUntilDate
      ).format('MMMM DD, YYYY')
    },
    addAnotherPdc() {
      this.entries.push({ ...this.pdcEntry })
    },
    removePDC(index) {
      this.entries.splice(index, 1)
    },
    async finish() {
      try {
        if (
          await this.$root.$confirm({
            title: 'Process PDCs',
            message:
              'Are you sure you would like to update the post dated checks?'
          })
        ) {
          this.finishLoading = true
          for (let index in this.entries) {
            const entry = this.entries[index]
            await this.$store.dispatch('pdcs/createPDCAction', {
              propertyId: this.propertyId,
              tenantId: entry.tenantId,
              checkNumber: entry.checkNumber,
              accountNumber: entry.accountNumber,
              bank: entry.bank,
              routingNumber: entry.routingNumber,
              amount: entry.amount,
              attachments: entry.attachments,
              description: entry.description,
              dueDate: dayjs(entry.date).format(),
              startDate: dayjs(entry.startDate).format(),
              endDate: dayjs(entry.endDate).format(),
              leaseId: entry.unit.leaseId,
              category: entry.category
            })
          }

          await this.$root
            .$confirm({
              title: 'Create Post Dated Check',
              message: `The Post Dated Checks have been created.`,
              reconfirmOnly: true,
              confirmText: 'OK',
              options: {
                color: 'success'
              }
            })
            .then(() => {
              // window.location.reload()
              this.dialog = false
              this.$router.push('/pdcs')
            })
        }
        this.finishLoading = false
      } catch (err) {
        this.finishLoading = false
        this.$root.$confirm({
          title: 'Create Post Dated Check',
          message: err,
          options: {
            color: 'error'
          },
          reconfirmOnly: true,
          confirmText: 'OK'
        })
      }
    }
  }
}
</script>
